import buildRoutes from 'ember-engines/routes';
export default buildRoutes(function () {
  // route map

  // engine landing page (overview)
  this.route('overview', {
    path: '/'
  });

  // billing
  this.route('billing', function () {
    this.route('index', {
      path: '/'
    });
    this.route('edit');
  });

  // apps
  this.route('apps', function () {
    this.route('index', {
      path: '/'
    });
    this.route('create');
    this.route('app', {
      path: '/:app_name'
    }, function () {
      // landing page
      this.route('index', {
        path: '/'
      });
      this.mount('role-assignments', {
        as: 'role-assignments',
        path: '/role-assignments'
      });
      this.route('activity-logs');
      this.route('secrets', function () {
        this.route('create', function () {
          this.route('dynamic');
          this.route('rotating');
        });
        this.route('import');
      });
      this.route('integrations', function () {
        // the index route serves as the "integrations" landing page
        this.route('index', {
          path: '/'
        });
        this.route('details', {
          path: '/:integration_type'
        }, function () {
          this.route('index', {
            path: '/'
          });
          this.route('configure');
        });
        this.route('github-actions', function () {
          this.route('index', {
            path: '/'
          });
          this.route('configure');
        });
        this.route('terraform', function () {
          this.route('index', {
            path: '/'
          });
        });
        this.route('vercel', function () {
          this.route('index', {
            path: '/'
          });
          this.route('configure');
        });
      });
      this.route('secret', function () {
        this.route('index', {
          path: '/'
        });
        this.route('details', {
          path: '/:secret_name'
        }, function () {
          this.route('index', {
            path: '/'
          });
          this.route('edit');
        });
      });
    });
  });
  this.route('integrations', function () {
    this.route('create', function () {
      this.route('dynamic');
      this.route('rotation');
    });
    this.route('sync', function () {
      this.route('details', {
        path: '/:integration_name'
      });
    });
    this.route('details', {
      path: '/:integration_name'
    }, function () {
      this.route('index', {
        path: '/'
      });
      this.route('edit');
    });
  });
});